<template>
  <ancestryline-modal title="protocol.tab-timeline.timeline-information"  id="add-timeline-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-select @input="autoSetTimelineEntity($event)" label="protocol.tab-timeline.select-predefined-timeline" class="p-col-12 p-md-6 p-lg-6" :options="timelinesPredefined"/>
    </card>
      
    <card>
      <coff-input-text v-model="timelineEntity.name" label="protocol.tab-timeline.name" class="p-col-12 p-md-6 p-lg-6" :error="validation.name"/>
      <coff-input-select v-model="timelineEntity.color" label="protocol.tab-timeline.status" class="p-col-12 p-md-6 p-lg-6"  :options="statusList" option-value="id" :error="validation.color"/>
      <coff-input-date v-model="timelineEntity.displayDate" label="protocol.tab-timeline.displayDate" class="p-col-12 p-md-6 p-lg-6" :showTime="true" type="datetime" :error="validation.displayDate"/>
      <coff-input-radio v-model="timelineEntity.toDisplay" @update="forceUpdateField('toDisplay', $event)" :options="isToDisplayOption" label="protocol.tab-timeline.isToDisplay" class="p-col-12 p-md-6 p-lg-6" :error="validation.toDisplay"/>
      <coff-input-text-editor v-model="timelineEntity.description" label="protocol.tab-timeline.description" class="p-col-12" :error="validation.description"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <Button :label="$t('btn.save')" @click="save" class="p-ml-auto p-button-success"/>
    </template>
  </ancestryline-modal>
</template>

<script>
import ValidationUtils from "@/utils/ValidationUtils";
import DialogService from "@/business/ModalBusiness";
import { LIST_OF_STATUS } from "@/constants/Timeline";

export default {
  name: "ModalTimeline",

  props: ["timelineEntity", "protocolId", "timelinesPredefined"],

  data(){
      return {
          validation: {
            name: false,
            color: false,
            displayDate: false,
            toDisplay: false,
            description: false,
          },
          statusList: LIST_OF_STATUS,
          isToDisplayOption: [
            {value: true, label: 'field.default.yes'},
            {value: false, label: 'field.default.no'}
          ],
      }
  },

  async mounted() {
    this.timelineEntity.displayDate = this.timelineEntity.displayDate ? new Date(this.timelineEntity.displayDate) : new Date();
  },

  methods: {
    close(){
      DialogService.closeModal();
    },

    save(){
        this.validation = ValidationUtils.basicValidation(this.validation, this.timelineEntity);
        if(!this.validation.erros){
          // Ajusta displayDate para string local no formato 'YYYY-MM-DD HH:mm:ss'
          if (this.timelineEntity.displayDate instanceof Date) {
            const d = this.timelineEntity.displayDate;
            const pad = n => n.toString().padStart(2, '0');
            const localDate = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.0001`;
            this.timelineEntity.displayDate = localDate;
          }
          DialogService.closeModal(this.timelineEntity);
        }
    },

    forceUpdateField(field, value){
        this.$set(this.timelineEntity, field, value);
    },

    autoSetTimelineEntity(value) {
      if (value && value.content && value.name) {
        this.$set(this.timelineEntity, 'description', value.content);
        this.$set(this.timelineEntity, 'name', value.name);
      }
    }
  },

}
</script>

<style scoped>

</style>